import { useFormContext } from 'react-hook-form';
import { Dialog } from '@optimus-web/core';
import { DropzoneField } from '@mews-commander/form';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ACCEPTED_IMAGE_TYPES } from './utils';
import {
    ProfilePictureFormData,
    ProfilePictureFormField,
    useUploadProfilePhotoForm,
} from './useUploadProfilePhotoForm';

export const UploadProfilePhotoDialog = ({ onClose }: { onClose: () => void }) => {
    const { renderFormContent, submit, isLoading } = useUploadProfilePhotoForm({ onClose });

    return (
        <Dialog
            size="small"
            active
            onClose={onClose}
            title={<LocalizedText textKey={TextKey.UploadProfilePhoto} />}
            loading={isLoading}
            actions={[
                {
                    children: <LocalizedText textKey={TextKey.Cancel} />,
                    onClick: onClose,
                    variant: 'tertiary',
                    type: 'button',
                },
                {
                    children: <LocalizedText textKey={TextKey.Upload} />,
                    onClick: submit,
                    variant: 'primary',
                    type: 'submit',
                },
            ]}
        >
            {renderFormContent(<UploadProfilePhotoDialogContainer />)}
        </Dialog>
    );
};

const UploadProfilePhotoDialogContainer = () => {
    const { trigger } = useFormContext<ProfilePictureFormData>();

    const validateFiles = async () => {
        await trigger(ProfilePictureFormField.Files);
    };

    return (
        <DropzoneField
            name={ProfilePictureFormField.Files}
            label={<LocalizedText textKey={TextKey.UploadProfilePhotoLabel} />}
            helper={<LocalizedText textKey={TextKey.ClickToUploadPhoto} />}
            uploadFilesText={<LocalizedText textKey={TextKey.ClickToUploadPhoto} />}
            onChange={validateFiles}
            accept={ACCEPTED_IMAGE_TYPES.join(',')}
            required
        />
    );
};
